import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-basic-button_edit",
  "use": "icon-basic-button_edit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-basic-button_edit\"><g><path d=\"M10.836 11.893l9.228-9.228a.882.882 0 111.248 1.248l-9.228 9.228a.882.882 0 11-1.248-1.248z\" /><path d=\"M21 12.612h0v6.674C21 20.785 19.785 22 18.286 22H4.714A2.714 2.714 0 012 19.286V5.714C2 4.215 3.215 3 4.714 3h6.883\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\" stroke-linecap=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol